// Importaciones necesarias
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom"; // Para obtener parámetros de la URL
import Navbar from "../components/navbar";
import Footer from "../components/footer";
// Importamos los tres tipos de layouts posibles
import Ejemplo1 from "../components/Producto"; // Layout para landings generales
import Ejemplo2 from "../components/Vertical"; // Layout para comercios
import Ejemplo3 from "../components/Brand"; // Layout para ventas
import SkeletonLoader from "../components/SkeletonLoader";
import Switcher from "../components/switcher";
import axios from "axios";

export default function Landing() {
  // Obtenemos el slug de la URL (ej: /info/mi-landing)
  const { slug } = useParams();

  // Estados para manejar la landing page
  const [landing, setLanding] = useState(null); // Datos de la landing
  const [loading, setLoading] = useState(true); // Estado de carga
  const [error, setError] = useState(null); // Manejo de errores

  // Efecto para cargar los datos de la landing cuando cambia el slug
  useEffect(() => {
    async function fetchLanding() {
      const urlApi = process.env.REACT_APP_STRAPI_URL;

      setLoading(true);
      setError(null);

      // Definimos los tres posibles endpoints donde podría estar la landing
      // Cada endpoint tiene su propia estructura de datos y tipo de página
      const endpoints = [
        {
          url: `${urlApi}/api/landings?filters[slug]=${slug}&populate[video][populate]=*&populate[seo][populate]=*&populate[beneficio][populate]=*&populate[testimonio][populate]=*&populate[marcas][populate]=*&populate[box][populate]=*&populate[hero][populate]=*&populate[titulo_box_1][populate]=*&populate[titulo_box_2][populate]=*
          `,
          type: "landing",
        },
        {
          url: `${urlApi}/api/ventas?filters[slug][$eq]=${slug}&populate[hero][populate]=*&populate[seo][populate]=*&populate[titulo1][populate]=*&populate[beneficio][populate]=*&populate[clientes][populate]=*&populate[video1][populate]=*&populate[video2][populate]=*&populate[titulo2][populate]=*&populate[experiencias][populate]=*&populate[titulo_box_1][populate]=*&populate[titulo_box_2][populate]=*
          `,
          type: "venta",
        },
        {
          url: `${urlApi}/api/comercios?filters[slug][$eq]=${slug}&populate[hero][populate]=*&populate[video][populate]=*&populate[titulo1][populate]=*&populate[clientes][populate]=*&populate[experiencias][populate]=*&populate[seo][populate]=*&populate[titulo2][populate]=*&populate[beneficios][populate]=*&populate[titulo_box_2][populate]=*`,
          type: "comercio",
        },
      ];

      try {
        for (const endpoint of endpoints) {
          const res = await axios.get(endpoint.url);
          if (res.data.data && res.data.data.length > 0) {
            const data = res.data.data[0];
            data.pageType = endpoint.type; // Añadimos el tipo de página para referencia
            setLanding(data);
            return; // Si encontramos datos, salimos del bucle
          }
        }
        // Si llegamos aquí es que no se encontró la landing en ningún endpoint
        setError("Landing no encontrada");
      } catch (err) {
        console.error("Error al cargar la landing:", err);
        setError("Error al cargar la landing...");
      } finally {
        setLoading(false);
      }
    }
    fetchLanding();
  }, [slug]);

  if (loading) return <SkeletonLoader />;
  if (error)
    return (
      <div className="text-sidom-orange bg-sidom-blue h-screen text-center py-20">
        <div className="flex mt-[100px] flex-col text-3xl font-extrabold  items-center w-full justify-center">
          <div>{error}</div>
        </div>
      </div>
    );
  if (!landing) return null;

  // Función que determina qué componente renderizar basado en el tipo de página
  const renderLayout = () => {
    // Mapeo de tipos de página a componentes
    const pageTypeToComponent = {
      landing: Ejemplo1, // Para landing pages generales
      comercio: Ejemplo2, // Para páginas de comercio
      venta: Ejemplo3, // Para páginas de venta
    };

    // Obtener el componente correspondiente al tipo de página
    const Component = pageTypeToComponent[landing.pageType];

    // Si existe un componente para este tipo, renderizarlo con los datos
    if (Component) {
      return <Component {...landing} />; // Pasamos todos los datos como props
    }

    return (
      <div className="text-sidom-orange bg-sidom-blue h-screen text-center py-20">
        <div className="flex flex-col items-center w-full h-screen justify-center">
          <div>
            <h1 className="text-4xl font-bold">Error</h1>
            <p className="mt-4">
              No se pudo encontrar el layout para esta página.
            </p>
          </div>
        </div>
      </div>
    );
  };

  // Renderizado principal de la página
  return (
    <>
      <header>
        <Navbar /> {/* Barra de navegación común para todas las páginas */}
      </header>
      <main>
        {renderLayout()}{" "}
        {/* Renderiza el layout específico según el tipo de página */}
      </main>
      <footer>
        <Footer /> {/* Pie de página común */}
      </footer>
      <Switcher /> {/* Componente para cambiar entre modo claro/oscuro */}
    </>
  );
}
